import React, { useEffect } from "react";
import { useState } from "react";
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import {
  getAllCircleWiseReport,
  getAllZoneWiseReport,
  innergetZoneActiveReport,
  innergetTotalZoneActiveReport1,
  innerTotalgetNotReportedAtWard1,
} from "../../../Apis/satReportsApi";
import { AllOwnerTypeDetails } from "../../../Apis/ownerTypeApi";
import { getAllTransferStationMaster } from "../../../Apis/transferStationApi";
import { AllVehicleDetails } from "../../../Apis/vehicleApi";
import { CreatableSelect } from "@atlaskit/select";
//import { AllVehicleTypeDetails } from "../../../Apis/vehicleApi";
import {
  innergetAllZoneWiseReport,
  innergetVehicleReport,
  innergetUnderRepairVehicleReport,
  innergetCondemnedVehicleReport,
  innergetTotalReport,
  innergetTotalReportCircleWise,
  innergetCircleActiveReport,
  innergetCondemnedReportCircleWise,
  innergetUnderRepairReportCircleWise,
  innergetActiveCircleReport,
  innergetReportedTsNotWardReportZoneWise,
  innergetReportedTsNotWardReportCircleWise,
  innergetReportedAtWardCircleWise,
  innergetReportedAtWardWise,
  innergetReportedAtWardAndTS,
  innergetReportedAtWardAndTSCircle,
  innergetNotReportedAtWard,
  innergetNotReportedAtWardCircle,
  innergetReportedAtWardNotTS,
  innergetReportedAtWardNotTSCircle,
  innergetZoneInActiveReport,
  innergetCircleInActiveReport,
  AllVehicleDetailsByCollectionTypeId,
  innergetTotalReportAllZones,
  innergetZonesVehicleReport,
  innergetCondemnedVehicleReportAllZones,
  innergetTotalZoneActiveReport,
  innergetZoneTotalInActiveReport,
  innerTotalgetReportedAtWardWise,
  innerTotalgetNotReportedAtWard,
  innerTotalgetReportedAtWardAndTS,
  innerTotalgetReportedAtWardNotTS,
  innerTotalgetReportedTsNotWardReportZoneWise,
  innergetTotalReportCircleWiseCircle,
  innergetCondemnedReportCircleWiseCircle,
  innergetUnderRepairReportCircleWiseTotal,
  innergetCircleInActiveReportTotal,
  innergetActiveCircleReportTotal,
  innergetReportedAtWardCircleWiseTotal,
  innergetNotReportedAtWardCircleTotal,
  innergetReportedAtWardAndTSCircleTotal,
  innergetReportedAtWardNotTSCircleTotal,
  innergetReportedTsNotWardReportCircleWiseTotal,
} from "../../../Apis/satReportsApi";
import { TableLoader } from "../../../Common/ShimmerLoader";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import ExcelJS from "exceljs";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import isGHMC, { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";
import useFilterStore from "./store/useFilterStore";

function DetailedReport() {
  const {
    zoneWiseFilters,
    circleWiseFilters,
    setZoneWiseFilter,
    setCircleWiseFilter,
    resetZoneWiseFilters,
    resetCircleWiseFilters,
    searchZoneWise,
    searchCircleWise,
    tab,
    setTab,
  } = useFilterStore();
  const getCurrentDate = new Date().toLocaleDateString("en-CA");

  const OwnerType = localStorage.getItem("SatZoneOwnerType");
  // const activeTab = localStorage.getItem("satActiveTab");
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(tab || 0);
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [ownerTypeDetailsCircle, setOwnerTypeDetailsCircle] = useState([]);
  const [transferstationDetails, setTransferstationDetails] = useState([]);
  const [transferstationDetailsCircle, setTransferstationDetailsCircle] =
    useState([]);
  const [VehicleNumberDetails, setVehicleNumberDetails] = useState([]);
  const [VehicleNumberDetailsCircle, setVehicleNumberDetailsCircle] = useState(
    []
  );
  const [optionsLoadingValues, setOptionLoadingValues] = useState([]);
  const [opts, setOpts] = useState(optionsLoadingValues);
  const [
    optionsCircleTransferstationValues,
    setOptionCircleTransferstationValues,
  ] = useState([]);
  const [optsTransferstation, setOptsTransferstation] = useState(
    optionsCircleTransferstationValues
  );
  const [optionsVehicleValues, setOptionVehicleValues] = useState([]);
  const [optsVehicle, setOptsVehicle] = useState(optionsVehicleValues);
  const [optionsVehicleCircleValues, setOptionVehicleCircleValues] = useState(
    []
  );
  const [optsVehicleCircle, setOptsVehicleCircle] = useState(
    optionsVehicleCircleValues
  );
  const [selectedOwnerType, setSelectedOwnerType] = useState(OwnerType || "");
  const [selectedOwnerTypeCircle, setSelectedOwnerTypeCircle] = useState("");
  const [getZoneReport, setgetZoneReport] = useState([]);
  const [getCircleReport, setgetCircleReport] = useState([]);
  const [selectedTransferstation, setSelectedTransferstation] = useState([]);
  const [selectedTransferstationCircle, setSelectedTransferstationCircle] =
    useState([]);
  const [selectedVehilceNo, setSelectedVehicleNo] = useState([]);
  const [selectedVehilceNoCircle, setSelectedVehicleNoCircle] = useState([]);
  // const [Date, setDate] = useState(getCurrentDateTime());
  const [vehicleTypeId, setVehicleTypeId] = useState("");
  const [vehicleData, setVehicleData] = useState([]);
  const isProd = isGHMC();

  const [formInput, setFormInput] = useState({
    Date: zoneWiseFilters ? zoneWiseFilters.date : getCurrentDateTime(),
    VehicleTypeId: zoneWiseFilters.VehicleTypeId || "",
    VehicleStatusId: "2",
    ownerType: zoneWiseFilters.ownerType || "",
    vehicleId: zoneWiseFilters.vehicleId || "",
    transferStationId: zoneWiseFilters.transferStationId || "",
  });

  const [formInput2, setFormInput2] = useState({
    Date: getCurrentDateTime(),
    VehicleTypeId: "",
  });
  const [formInput1, setFormInput1] = useState({
    Date: getCurrentDateTime(),
    VehicleTypeId: "",
  });
  const conditionalRowStyles = [
    {
      when: (row) => row.slno === "Total", // Assuming 'slno' indicates the row is a total row
      style: {
        backgroundColor: "lightgrey", // Set your desired background color here
      },
    },
  ];
  const satZoneColumns = [
    {
      name: "S.No",
      selector: (row) => row["slno"],
      format: (row, rowIndex) => {
        if (row.zoneName === "Total") {
          return null;
        }
        return rowIndex + 1;
      },
      width: "70px", // Reduced from 90px
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => (
        <span
          style={{ color: `${row.zoneName === "Total" ? "black" : "blue"}`, cursor: "pointer" }}
          onClick={() => row.zoneName !== "Total" && handleZoneClick(row["zoneId"])}
        >
          {row["zoneName"]}
        </span>
      ),
      width: "120px", // Added default width
    },
    {
      name: "Total Vehicles",
      selector: (row) => row["totalVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalAllZonesClick();
            } else {
              handleTotalClick(row["zoneId"]);
            }
          }}
        >
          {row["totalVehicles"]}
        </span>
      ),
      width: "120px", // Added default width
    },
    {
      name: <>Condemned<br />Vehicles</>,
      selector: (row) => row["condemnedVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalCondemnedClick();
            } else {
              handleCondemnedClick(row["zoneId"]);
            }
          }}
        >
          {row["condemnedVehicles"]}
        </span>
      ),
      width: "120px", // Reduced from 210px
    },
    {
      name: <>Repair<br />Vehicles</>,
      selector: (row) => row["repairVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleUnderRepairTotalClick();
            } else {
              handleUnderRepairClick(row["zoneId"]);
            }
          }}
        >
          {row["repairVehicles"]}
        </span>
      ),
      width: "120px", // Reduced from 210px
    },
    {
      name: <>Total InActive<br />Vehicles</>,
      selector: (row) => row["totalInActive"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleInActiveClickTotal();
            } else {
              handleInActiveClick(row["zoneId"]);
            }
          }}
        >
          {row["totalInActive"]}
        </span>
      ),
      width: "120px", // Reduced from 230px
    },
    {
      name: <>Active<br />Vehicles</>,
      selector: (row) => row["activeVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalActiveClick();
            } else {
              handleActiveClick(row["zoneId"]);
            }
          }}
        >
          {row["activeVehicles"]}
        </span>
      ),
      width: "120px", // Reduced from 180px
    },
    {
      name: <>Reported at<br />Ward</>,
      selector: (row) => row["reportedAtWard"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalReportedAtWardClick();
            } else {
              handleReportedAtWardClick(row);
            }
          }}
        >
          {row["reportedAtWard"]}
        </span>
      ),
      width: "120px", // Reduced from 220px
    },
    {
      name: <>Not Reported<br />at Ward</>,
      selector: (row) => row["notReportedAtWard"],
      cell: (row) => (
        <span
          style={{ color: "blue", width: "165px", cursor: "pointer" }} // Updated width to match column
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalNotReportedAtWardClick();
            } else {
              handleNotReportedAtWardClick(row["zoneId"]);
            }
          }}
        >
          {row["notReportedAtWard"]}
        </span>
      ),
      width: "120px", // Reduced from 230px
    },
    {
      name: <>Reported at<br />Ward & TS</>,
      selector: (row) => row["reportedAtWardAndTS"],
      cell: (row) => (
        <span
          style={{ color: "blue", width: "165px", cursor: "pointer" }} // Updated width to match column
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalReportedAtWardAndTSClick();
            } else {
              handleReportedAtWardAndTSClick(row["zoneId"]);
            }
          }}
        >
          {row["reportedAtWardAndTS"]}
        </span>
      ),
      width: "120px", // Reduced from 230px
    },
    {
      name: <>Reported at Ward<br />Not TS</>,
      selector: (row) => row["reportedAtWardNotTS"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalReportedAtWardNotTSClick();
            } else {
              handleReportedAtWardNotTSClick(row["zoneId"]);
            }
          }}
        >
          {row["reportedAtWardNotTS"]}
        </span>
      ),
      width: "120px", // Reduced from 230px
    },
    {
      name: <>Reported at TS<br />Not Ward</>,
      selector: (row) => row["reportedAtTSNotWard"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalReportedTsNotWard();
            } else {
              handleReportedTsNotWard(row["zoneId"]);
            }
          }}
        >
          {row["reportedAtTSNotWard"]}
        </span>
      ),
      // width: "120px", // Reduced from 230px
    },
  ];


  useEffect(() => {
    const fetchOwnerTypeData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetails(ownerTypeData);
        // console.log(ownerTypeData)
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchOwnerTypeData();
  }, []);
  useEffect(() => {
    const fetchOwnerTypeCircleData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetailsCircle(ownerTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchOwnerTypeCircleData();
  }, []);

  useEffect(() => {
    const fetchTransferstationData = async () => {
      try {
        const transferstationData = await getAllTransferStationMaster();
        setTransferstationDetails(transferstationData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchTransferstationData();
  }, []);

  useEffect(() => {
    const fetchTransferstationCircleData = async () => {
      try {
        const transferstationData = await getAllTransferStationMaster();
        setTransferstationDetailsCircle(transferstationData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchTransferstationCircleData();
  }, []);

  useEffect(() => {
    const fetchVehicleNumberData = async () => {
      try {
        const VehicleNumberData = await AllVehicleDetails();
        setVehicleNumberDetails(VehicleNumberData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleNumberData();
  }, []);

  useEffect(() => {
    const fetchVehicleNumberCircleData = async () => {
      try {
        const VehicleNumberData = await AllVehicleDetails();
        setVehicleNumberDetailsCircle(VehicleNumberData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleNumberCircleData();
  }, []);

  useEffect(() => {
    setOptionLoadingValues(
      transferstationDetails
        .filter((Transferstation) => Transferstation.isActive)
        .map((Transferstation) => ({
          value: Transferstation.transferStationId,
          label: Transferstation.transferStationName,
        }))
    );
  }, [transferstationDetails]);

  useEffect(() => {
    setOptionCircleTransferstationValues(
      transferstationDetailsCircle
        .filter((Transferstation) => Transferstation.isActive)
        .map((Transferstation) => ({
          value: Transferstation.transferStationId,
          label: Transferstation.transferStationName,
        }))
    );
  }, [transferstationDetailsCircle]);

  useEffect(() => {
    setOptionVehicleValues(
      VehicleNumberDetails
        .filter((VehicleNumber) => VehicleNumber.isActive)
        .map((VehicleNumber) => ({
          value: VehicleNumber.vehicleId,
          label: VehicleNumber.vehicleNumber,
        }))
    );
  }, [VehicleNumberDetails]);
  useEffect(() => {
    setOptionVehicleCircleValues(
      VehicleNumberDetailsCircle
        .filter((VehicleNumber) => VehicleNumber.isActive)
        .map((VehicleNumber) => ({
          value: VehicleNumber.vehicleId,
          label: VehicleNumber.vehicleNumber,
        }))
    );
  }, [VehicleNumberDetailsCircle]);
  // const inactiveSubColumns = [
  //   {
  //     name: "Condemned",
  //     selector: (row) => row["condemned"],
  //     sortable: true,
  //   },
  //   {
  //     name: "Under Repair",
  //     selector: (row) => row["underRepair"],
  //     sortable: true,
  //   },
  //   {
  //     name: "Total",
  //     selector: (row) => row.total - row.condemned - row.underRepair,
  //     sortable: true,
  //   },
  // ];
  const satCircleColumns = [
    {
      name: "S.No",
      selector: (row) => row["slno"],
      //   sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleZoneClick(row["circleId"])}
        >
          {row["circleName"]}
        </span>
      ),
      width: "120px",
      //   sortable: true,
    },
    {
      name: <>Total<br />Vehicles</>,
      selector: (row) => row["totalVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleTotalCircleVehicleClickCircle();
            } else {
              handleTotalCircleVehicleClick(row["circleId"]);
            }
          }}
        >
          {row["totalVehicles"]}
        </span>
      ),
      //  sortable: true,
      width: "120px",
    },
    {
      name: <>Condemned<br />Vehicles</>,
      selector: (row) => row["condemnedVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleCondemnedCircleClickTotal();
            } else {
              handleCondemnedCircleClick(row["circleId"]);
            }
          }}
        >
          {row["condemnedVehicles"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    {
      name: <>Repair<br />Vehicles</>,
      selector: (row) => row["repairVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleUnderRepaiCircleClickTotal();
            } else {
              handleUnderRepaiCircleClick(row["circleId"]);
            }
          }}
        >
          {row["repairVehicles"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    // {
    //   name: "totalInActive",
    //   selector: (row) => (
    //     <span
    //      style={{ color: "blue", cursor: "pointer" }}
    //       onClick={() => handleZoneClick(row["circleId"])} >{row["totalInActive"]}</span>
    //   ),
    //   sortable: true,
    // },
    {
      name: <>Total InActive Vehicles</>,
      selector: (row) => row["totalInActive"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleInActiveCicleClickTotal();
            } else {
              handleInActiveCicleClick(row["circleId"]);
            }
          }}
        >
          {row["totalInActive"]}
        </span>
      ),
      //     sortable: true,
      width: "120px",
    },
    {
      name: <>Active Vehicles</>,
      selector: (row) => row["activeVehicles"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleActiveCircleClickTotal();
            } else {
              handleActiveCircleClick(row["circleId"]);
            }
          }}
        >
          {row["activeVehicles"]}
        </span>
      ),
      //     sortable: true,
      width: "150px",
    },

    {
      name: <>Reported at Ward</>,
      selector: (row) => row["reportedAtWard"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedAtWardCircleClickTotal();
            } else {
              handleReportedAtWardCircleClick(row["circleId"]);
            }
          }}
        >
          {row["reportedAtWard"]}
        </span>
      ),
      width: "150px",
      //    sortable: true,
    },
    {
      name: <>Not Reported at Ward</>,
      selector: (row) => row["notReportedAtWard"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleNotReportedAtWardCircleClickTotal();
            } else {
              handleNotReportedAtWardCircleClick(row["circleId"]);
            }
          }}
        >
          {row["notReportedAtWard"]}
        </span>
      ),
      //   sortable: true,
      width: "150px",
    },
    {
      name: <>Reported at Ward & TS</>,
      selector: (row) => row["reportedAtWardAndTS"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedAtWardAndTSCircleClickTotal();
            } else {
              handleReportedAtWardAndTSCircleClick(row["circleId"]);
            }
          }}
        >
          {row["reportedAtWardAndTS"]}
        </span>
      ),
      //   sortable: true,
      width: "150px",
    },
    {
      name: <>Reported at Ward Not TS</>,
      selector: (row) => row["reportedAtWardNotTS"],
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedAtWardNotTSCircleClickTotal();
            } else {
              handleReportedAtWardNotTSCircleClick(row["circleId"]);
            }
          }}
        >
          {row["reportedAtWardNotTS"]}
        </span>
      ),
      //    sortable: true,
      width: "120px",
    },
    {
      name: <>Reported at TS Not Ward</>,
      selector: (row) => row["reportedAtTSNotWard"],
      cell: (row) => (
        // <span
        //   style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleReportedTsNotWardCircle(row["circleId"])}
        // >
        //   {row["reportedAtTSNotWard"]}
        // </span>
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleReportedTsNotWardCircleTotal();
            } else {
              handleReportedTsNotWardCircle(row["circleId"]);
            }
          }}
        >
          {row["reportedAtTSNotWard"]}
        </span>
      ),
      //    sortable: true,
      // width: "120px",
    },
  ];
  const handleCondemnedClick = async (ZoneId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetVehicleReport({
        // Date:formInput.Date,

        ZoneId: ZoneId,
        CollectionTypeId: "1",
        VehicleStatusId: formInput.VehicleStatusId,
        allZones: false,

        Date: zoneWiseFilters.date,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      // console.log(response, "innergetVehicleReport");
      navigate("/view-sat-vehicle-report", { state: {data:response,fromDate:zoneWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalCondemnedClick = async () => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetCondemnedVehicleReportAllZones({
        CollectionTypeId: "1",
        allZones: true,
        VehicleStatusId: "2",

        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      // console.log(response, "innergetCondemnedVehicleReportAllZones");
      navigate("/view-sat-vehicle-report", { state: {data:response,fromDate:zoneWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleReportedTsNotWard = async (zoneId) => {
    try {
      setIsOptionsLoading(true);
      const currentDate = new Date().toLocaleDateString("en-CA");

      const response = await innergetReportedTsNotWardReportZoneWise({
        CollectionTypeId: "1",
        allZones: false,

        zoneId: zoneId,
        date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/reported-ts-notward-zone", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalReportedTsNotWard = async () => {
    try {
      setIsOptionsLoading(true);
      const response = await innerTotalgetReportedTsNotWardReportZoneWise({
        // Date:formInput.Date,
        CollectionTypeId: "1",
        allZones: true,

        date: zoneWiseFilters.date || getCurrentDate,
        vehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerType: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/reported-ts-notward-zone", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleReportedTsNotWardCircle = async (CircleId) => {
    try {
      setIsOptionsLoading(true);
      const currentDate = new Date().toLocaleDateString("en-CA");

      const response = await innergetReportedTsNotWardReportCircleWise({
        CircleId: CircleId,

        date: circleWiseFilters.date || currentDate,
        vehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/reported-ts-notward-circle", { state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleReportedTsNotWardCircleTotal = async (CircleId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetReportedTsNotWardReportCircleWiseTotal({
        date: circleWiseFilters.date || getCurrentDate,
        vehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/reported-ts-notward-circle-total", { state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCondemnedCircleClick = async (CircleId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetCondemnedReportCircleWise({
        CircleId: CircleId,
        CollectionTypeId: "1",
        VehicleStatusId: formInput.VehicleStatusId,

        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/circle-condemned-report", { state: {data:response} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleCondemnedCircleClickTotal = async (CircleId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetCondemnedReportCircleWiseCircle({
        CollectionTypeId: "1",
        VehicleStatusId: formInput.VehicleStatusId,

        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/circle-condemned-circle-report", { state: {data:response} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalCircleVehicleClick = async (CircleId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetTotalReportCircleWise({
        CircleId: CircleId,
        CollectionTypeId: "1",

        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });

      navigate("/sat-circle-total-report", { state: {data:response} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalCircleVehicleClickCircle = async (CircleId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetTotalReportCircleWiseCircle({
        CollectionTypeId: "1",
        allCircles: true,
        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/sat-circle-total-wise-report", { state: {data:response} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleActiveCircleClick = async (CircleId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetActiveCircleReport({
        CircleId: CircleId,
        CollectionTypeId: "1",
        IsActive: true,

        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/circle-active-report", { state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleActiveCircleClickTotal = async (CircleId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetActiveCircleReportTotal({
        CollectionTypeId: "1",
        IsActive: true,

        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/circle-active-total-report", { state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleActiveClick = async (ZoneId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetZoneActiveReport({
        // Date:formInput.Date,
        CollectionTypeId: "1",
        ZoneId: ZoneId,
        VehicleStatusId: null,
        IsActive: true,
        allZones: false,

        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/sat-active-report", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalActiveClick = async () => {
    try {
      setIsOptionsLoading(true);
      const currentDate = new Date().toLocaleDateString("en-CA");

      const response = await innergetTotalZoneActiveReport1({
        CollectionTypeId: "1",
        VehicleStatusId: "1",
        IsActive: true,
        allZones: true,

        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/sat-active-report", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleInActiveClick = async (ZoneId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetZoneInActiveReport({
        CollectionTypeId: "1",
        VehicleStatusId: "1",
        IsActive: false,

        ZoneId: ZoneId,
        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/sat-inactive-report", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleInActiveClickTotal = async (ZoneId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetZoneTotalInActiveReport({
        // Date:formInput.Date,
        CollectionTypeId: "1",
        VehicleStatusId: "1",
        IsActive: false,

        ZoneId: ZoneId,
        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/sat-inactive-report", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleInActiveCicleClick = async (CircleId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetCircleInActiveReport({
        CollectionTypeId: "1",
        CircleId: CircleId,
        VehicleStatusId: "1",
        IsActive: false,

        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/circle-inactive-report", { state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleInActiveCicleClickTotal = async (CircleId) => {
    try {
      setIsOptionsLoading(true);
      const response = await innergetCircleInActiveReportTotal({
        CollectionTypeId: "1",
        VehicleStatusId: "1",
        IsActive: false,

        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerType: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/circle-inactive-total-report",{ state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalClick = async (ZoneId) => {
    try {
      //console.log(formInput,'forminputrrr')
      setIsOptionsLoading(true);
      const response = await innergetTotalReport({
        CollectionTypeId: "1",
        allZones: false,
        ZoneId: ZoneId,
        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/sat-total-report", { state: {data:response,fromDate:zoneWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalAllZonesClick = async () => {
    try {
      //console.log(formInput,'forminputrrr')
      setIsOptionsLoading(true);
      const response = await innergetTotalReportAllZones({
        CollectionTypeId: "1",
        allZones: true,

        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/sat-total-report", { state: {data:response,fromDate:zoneWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleUnderRepairClick = async (ZoneId, VehicleStatusId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const response = await innergetUnderRepairVehicleReport({
        ZoneId: ZoneId,
        VehicleStatusId: "3",
        CollectionTypeId: "1",
        allZones: false,

        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      // console.log(response, "this is res");
      navigate("/sat-under-repair-report", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleUnderRepairTotalClick = async () => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const response = await innergetUnderRepairVehicleReport({
        CollectionTypeId: "1",
        VehicleStatusId: "3",
        allZones: true,
        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      // console.log(response, "this is res");
      navigate("/sat-under-repair-report", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleUnderRepaiCircleClick = async (CircleId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const response = await innergetUnderRepairReportCircleWise({
        CircleId: CircleId,
        VehicleStatusId: "3",

        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/circle-under-repair-report", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleUnderRepaiCircleClickTotal = async (CircleId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const response = await innergetUnderRepairReportCircleWiseTotal({
        VehicleStatusId: "3",

        Date: circleWiseFilters.date,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/circle-under-repair-total-report", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleReportedAtWardClick = async (row) => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = zoneWiseFilters.date
      ? zoneWiseFilters.date
      : getCurrentDateTime();
    // console.log("checking the date", Date);
    // Concatenate start and end times with the date
    const startDate = `${Date}T${startTime}`;
    const endDate = `${Date}T${endTime}`;

    try {
      setIsOptionsLoading(true);
      // console.log({
      //   startDate: startDate,
      //   endDate: endDate,
      //   ZoneId: row.zoneId,
      //   CollectionTypeId: "1",
      //   allZones: false,

      //   VehicleTypeId: zoneWiseFilters.VehicleTypeId,
      //   ownerType: zoneWiseFilters.ownerTypeId,
      //   vehicleId: zoneWiseFilters.vehicleId,
      //   transferStationId: zoneWiseFilters.transferStationId,
      //   vehicleNumber: zoneWiseFilters.vehicleNumber,
      // });
      let response = await innergetReportedAtWardWise({
        startDate: startDate,
        endDate: endDate,
        ZoneId: row.zoneId,
        CollectionTypeId: "1",
        allZones: false,

        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      //  console.log("zoneIddffff",ZoneId)
      navigate("/reported-ward-zone", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalReportedAtWardClick = async (row) => {
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = zoneWiseFilters.date
      ? zoneWiseFilters.date
      : getCurrentDateTime();
    // const Date = formInput.Date;
    // Concatenate start and end times with the date
    const startDate = `${Date}T${startTime}`;
    const endDate = `${Date}T${endTime}`;

    try {
      setIsOptionsLoading(true);
      let response = await innerTotalgetReportedAtWardWise({
        startDate: startDate,
        endDate: endDate,
        CollectionTypeId: "1",
        allZones: true,

        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/reported-ward-zone", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleReportedAtWardAndTSClick = async (ZoneId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const currentDate = new Date().toLocaleDateString("en-CA");
      const response = await innergetReportedAtWardAndTS({
        CollectionTypeId: "1",
        allZones: false,

        ZoneId: ZoneId,
        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/reported-wardts-zone", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalReportedAtWardAndTSClick = async () => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const response = await innerTotalgetReportedAtWardAndTS({
        CollectionTypeId: "1",
        allZones: true,

        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/reported-wardts-zone", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleReportedAtWardAndTSCircleClick = async (CircleId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);

      const currentDate = new Date().toLocaleDateString("en-CA");

      const response = await innergetReportedAtWardAndTSCircle({
        CircleId: CircleId,

        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/reported-wardts-circle", { state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleReportedAtWardAndTSCircleClickTotal = async (CircleId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const response = await innergetReportedAtWardAndTSCircleTotal({
        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/reported-wardts-circle-total",{ state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleNotReportedAtWardClick = async (ZoneId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const currentDate = new Date().toLocaleDateString("en-CA");
      const response = await innergetNotReportedAtWard({
        ZoneId: ZoneId,
        CollectionTypeId: "1",
        allZones: false,

        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/not-reported-ward-zone", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalNotReportedAtWardClick = async () => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const response = await innerTotalgetNotReportedAtWard1({
        CollectionTypeId: "1",
        allZones: true,

        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/not-reported-ward-zone", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleNotReportedAtWardCircleClick = async (CircleId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const currentDate = new Date().toLocaleDateString("en-CA");

      const response = await innergetNotReportedAtWardCircle({
        CircleId: CircleId,

        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/not-reported-ward-circle", { state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleNotReportedAtWardCircleClickTotal = async (CircleId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const response = await innergetNotReportedAtWardCircleTotal({
        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/not-reported-ward-circle-total", { state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleReportedAtWardNotTSClick = async (ZoneId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const currentDate = new Date().toLocaleDateString("en-CA");

      const response = await innergetReportedAtWardNotTS({
        //  CollectionTypeId: "1",
        allZones: false,

        ZoneId: ZoneId,
        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/reported-ward-notts-zone", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleTotalReportedAtWardNotTSClick = async () => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const response = await innerTotalgetReportedAtWardNotTS({
        //   CollectionTypeId: "1",
        allZones: true,
        // ZoneId: ZoneId,
        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      });
      navigate("/reported-ward-notts-zone", { state: response });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleReportedAtWardNotTSCircleClick = async (CircleId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const currentDate = new Date().toLocaleDateString("en-CA");

      const response = await innergetReportedAtWardNotTSCircle({
        CircleId: CircleId,

        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/reported-ward-notts-circle",{ state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleReportedAtWardNotTSCircleClickTotal = async (CircleId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const response = await innergetReportedAtWardNotTSCircleTotal({
        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/reported-ward-notts-circle-total", { state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleReportedAtWardCircleClick = async (row) => {
    // console.log(row)
    const startTime = "00:00";
    const endTime = "23:59";
    const Date = circleWiseFilters.date
      ? circleWiseFilters.date
      : getCurrentDateTime();
    // Concatenate start and end times with the date
    const startDate = `${Date}T${startTime}`;
    const endDate = `${Date}T${endTime}`;
    try {
      setIsOptionsLoading(true);
      const response = await innergetReportedAtWardCircleWise({
        startDate: startDate,
        endDate: endDate,
        CircleId: row,
        allCircles: true,

        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/reported-ward-circle", { state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleReportedAtWardCircleClickTotal = async (row) => {
    const startTime = "00:00";
    const endTime = "23:59";
    // Concatenate start and end times with the date
    const Date = circleWiseFilters.date
      ? circleWiseFilters.date
      : getCurrentDateTime();
    const startDate = `${Date}T${startTime}`;
    const endDate = `${Date}T${endTime}`;
    try {
      setIsOptionsLoading(true);
      const response = await innergetReportedAtWardCircleWiseTotal({
        startDate: startDate,
        endDate: endDate,

        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerTypeId: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleNumber: circleWiseFilters.vehicleNumber,
      });
      navigate("/reported-ward-circle-total", { state:{data: response,fromDate:circleWiseFilters.date} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  // const handleZoneClick = async (ZoneId) => {
  //   try {
  //     setIsOptionsLoading(true);
  //     const requestData = { Date, VehicleTypeId: vehicleTypeId, ZoneId };
  //     const response = await innergetAllZoneWiseReport(requestData);
  //     navigate("/view-sat-zone-report", { state: response.data });
  //     console.log(response.data,"response")
  //   } catch (error) {
  //     console.error("Error fetching circle wise report:", error);
  //   } finally {
  //     setIsOptionsLoading(false);
  //   }
  // };

  const handleZoneClick = async (ZoneId) => {
    try {
      //console.log(formInput,'forminput2')
      setIsOptionsLoading(true);
      const payloads = {
        ZoneIds: ZoneId,
        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerTypeId: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleNumber: zoneWiseFilters.vehicleNumber,
      }
      const response = await innergetAllZoneWiseReport(payloads);
      navigate("/view-sat-zone-report", { state: {list: response, ...payloads} });
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicleData();
    searchZoneReport();
    searchCircleReport();
  }, []);

  const fetchVehicleData = async () => {
    setIsOptionsLoading(true);
    try {
      const requestData = { CollectionTypeId: "1" };
      const response = await AllVehicleDetailsByCollectionTypeId(requestData);

      if (Array.isArray(response.data)) {
        setVehicleData(response.data);
      } else {
        console.error("Response data is not an array:", response.data);
        // Optionally, handle this case or set a default value for vehicleData
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  // const searchZoneReport = async () => {
  //     setIsOptionsLoading(true);
  //     try {
  //         // const requestData = { Date, vehicleTypeId };
  //         const res = await getAllZoneWiseReport(Date,vehicleTypeId);
  //         setgetZoneReport(res.data.map(zoneData => ({ ...zoneData, zone: zoneData.zoneName })));
  //         console.log(Date,"requestDataaa")
  //     } catch (error) {
  //         console.log(error)
  //     } finally {
  //         setIsOptionsLoading(false);
  //     }
  // }

  const searchZoneReport = async () => {
    //  e.preventDefault(); // Make sure to prevent the default form submission behavior

    setIsOptionsLoading(true);
    setLoading(true)
    try {
      const res = await getAllZoneWiseReport({
        Date: zoneWiseFilters.date || getCurrentDate,
        VehicleTypeId: zoneWiseFilters.VehicleTypeId,
        ownerType: zoneWiseFilters.ownerTypeId,
        vehicleId: zoneWiseFilters.vehicleId,
        transferStationId: zoneWiseFilters.transferStationId,
        vehicleId: zoneWiseFilters.vehicleNumber,
      });
      const zoneDataResponse = res.data.map((zoneData) => ({
        ...zoneData,
        zone: zoneData.zoneName,
      }));
      setgetZoneReport(zoneDataResponse);
      // console.log(zoneDataResponse, "zoneresponse");
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
      setLoading(false)
    }
  };

  const searchCircleReport = async () => {
    //  e.preventDefault(); // Make sure to prevent the default form submission behavior

    setIsOptionsLoading(true);

    try {
      const res = await getAllCircleWiseReport({
        Date: circleWiseFilters.date || getCurrentDate,
        VehicleTypeId: circleWiseFilters.VehicleTypeId,
        ownerType: circleWiseFilters.ownerTypeId,
        vehicleId: circleWiseFilters.vehicleId,
        transferStationId: circleWiseFilters.transferStationId,
        vehicleId: circleWiseFilters.vehicleNumber,
      });

      const zoneDataResponse = res.data.map((zoneData) => ({
        ...zoneData,
        zone: zoneData.zoneName,
      }));
      setgetCircleReport(zoneDataResponse);

      // console.log(res.data, 'res.data from zone')
    } catch (error) {
      console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    searchZoneReport();
  };
  const handleSubmit1 = (e) => {
    e.preventDefault();
    searchCircleReport();
  };
  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;



  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}/${currentDate.getMonth() + 1
      }/${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Zone Wise SATs Report Generated on: ${formattedDates}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    const boldFont = { bold: true };

    // Add header rows
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 12);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };
    for (let col = 2; col <= 12; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    } worksheet.addRow(["", "", "Zone Wise SATs Report", ""]);
    worksheet.mergeCells(2, 2, 2, 12);
    worksheet.getCell(2, 2).value = `Zone Wise SATs Report - ${zoneWiseFilters.date ? formattedDate(zoneWiseFilters.date) : getCurrentISTDate()} - (at ${getCurrentDateTime1()})`;
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };
    for (let col = 2; col <= 12; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Table header
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Total Vehicles",
      "Condemned Vehicles",
      "Repair Vehicles",
      "Total InActive Vehicles",
      "Active Vehicles",
      "Reported at Ward",
      "Not Reported at Ward",
      "Reported at Ward & TS",
      "Reported at Ward Not TS",
      "Reported at TS Not Ward",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 12) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    // Initialize totals
    let totalVehicles = 0;
    let totalCondemned = 0;
    let totalUnderRepair = 0;
    let totalActive = 0;
    let totalInActive = 0;
    let totalReportedAtWard = 0;
    let totalNotReportedAtWard = 0;
    let totalReportedAtWardAndTS = 0;
    let totalReportedAtWardNotTS = 0;
    let totalReportedAtTSNotWard = 0;

    // Data rows and total calculation
    getZoneReport.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zone ?? "N/A",
          item.totalVehicles ?? "N/A",
          item.condemnedVehicles ?? "N/A",
          item.repairVehicles ?? "N/A",
          item.totalInActive ?? "N/A",
          item.activeVehicles ?? "N/A",
          item.reportedAtWard ?? "N/A",
          item.notReportedAtWard ?? "N/A",
          item.reportedAtWardAndTS ?? "N/A",
          item.reportedAtWardNotTS ?? "N/A",
          item.reportedAtTSNotWard ?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          cell.alignment = { horizontal: "left" };
        });

      // Accumulate totals
      totalVehicles += item.totalVehicles || 0;
      totalCondemned += item.condemnedVehicles || 0;
      totalUnderRepair += item.repairVehicles || 0;
      totalActive += item.activeVehicles || 0;
      totalInActive += item.totalInActive || 0;
      totalReportedAtWard += item.reportedAtWard || 0;
      totalNotReportedAtWard += item.notReportedAtWard || 0;
      totalReportedAtWardAndTS += item.reportedAtWardAndTS || 0;
      totalReportedAtWardNotTS += item.reportedAtWardNotTS || 0;
      totalReportedAtTSNotWard += item.reportedAtTSNotWard || 0;
    });

    // Total row
    const totalRow = worksheet.addRow([
      "",
      "Total",
      totalVehicles,
      totalCondemned,
      totalUnderRepair,
      totalInActive,
      totalActive,
      totalReportedAtWard,
      totalNotReportedAtWard,
      totalReportedAtWardAndTS,
      totalReportedAtWardNotTS,
      totalReportedAtTSNotWard,
    ]);
    totalRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
    });

    // Column widths
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 25 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 28 },
      { width: 28 },
      { width: 28 },
    ];

    // Save workbook
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ZoneWiseSATsReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };


  const option = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTimes = ` ${new Date()
    .toLocaleString("en-GB", option)
    .replace(/\//g, "/")}`;
  const downloadAsExcel1 = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}/${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Reported on: ${generationTimes}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the worksheet
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 12);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };
    for (let col = 2; col <= 12; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }
    // Add "Circle Wise SATs Report" heading
    worksheet.addRow(["", "", "Circle Wise SATs Report", ""]);
    worksheet.mergeCells(2, 2, 2, 12);
    worksheet.getCell(2, 2).value = `Circle Wise SATs Report ${circleWiseFilters.date ? formattedDate(circleWiseFilters.date) : getCurrentISTDate()} - (at ${getCurrentDateTime1()})`;
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };
    for (let col = 2; col <= 12; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }


    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Circle",
      "Total Vehicles",
      "Condemned Vehicles",
      "Repair Vehicles",
      "Total InActive Vehicles",
      "Active Vehicles",
      "Reported at Ward",
      "Not Reported at Ward",
      "Reported at Ward & TS",
      "Reported at Ward Not TS",
      "Reported at TS Not Ward",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 12) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Add data rows
    getCircleReport.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.circleName,
          item.totalVehicles,
          item.condemnedVehicles,
          item.repairVehicles,
          item.totalInActive,
          item.activeVehicles,
          item.reportedAtWard,
          item.notReportedAtWard,
          item.reportedAtWardAndTS,
          item.reportedAtWardNotTS,
          item.reportedAtTSNotWard,
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 12) {
            cell.alignment = { horizontal: "left" };
          } else {
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Calculate and add summary row at the end
    const totalVehicles = getCircleReport.reduce((sum, item) => sum + item.totalVehicles, 0);
    const totalCondemned = getCircleReport.reduce((sum, item) => sum + item.condemnedVehicles, 0);
    const totalUnderRepair = getCircleReport.reduce((sum, item) => sum + item.repairVehicles, 0);
    const totalInActive = getCircleReport.reduce((sum, item) => sum + item.totalInActive, 0);
    const totalActive = getCircleReport.reduce((sum, item) => sum + item.activeVehicles, 0);
    const totalReportedAtWard = getCircleReport.reduce((sum, item) => sum + item.reportedAtWard, 0);
    const totalNotReportedAtWard = getCircleReport.reduce((sum, item) => sum + item.notReportedAtWard, 0);
    const totalReportedAtWardAndTS = getCircleReport.reduce((sum, item) => sum + item.reportedAtWardAndTS, 0);
    const totalReportedAtWardNotTS = getCircleReport.reduce((sum, item) => sum + item.reportedAtWardNotTS, 0);
    const totalReportedAtTSNotWard = getCircleReport.reduce((sum, item) => sum + item.reportedAtTSNotWard, 0);

    // Add summary row
    worksheet.addRow([
      "",
      "Total",
      totalVehicles,
      totalCondemned,
      totalUnderRepair,
      totalInActive,
      totalActive,
      totalReportedAtWard,
      totalNotReportedAtWard,
      totalReportedAtWardAndTS,
      totalReportedAtWardNotTS,
      totalReportedAtTSNotWard,
    ]).eachCell({ includeEmpty: true }, (cell) => {
      cell.font = boldFont; // Bold the total row
      cell.alignment = { horizontal: "left" }; // Center align the total row
      // cell.fill = {
      //   type: "pattern",
      //   pattern: "solid",
      //   fgColor: { argb: "D9EAD3" }, // Light green background for totals
      // };
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 25 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 28 },
      { width: 26 },
      { width: 23 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "CircleWiseSATsReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };


  const calculateZoneTotals = (data) => {
    const totals = {
      slno: "Total",
      zoneName: "Total",
      totalVehicles: 0,
      condemnedVehicles: 0,
      repairVehicles: 0,
      activeVehicles: 0,
      totalInActive: 0,
      reportedAtWard: 0,
      notReportedAtWard: 0,
      reportedAtWardAndTS: 0,
      reportedAtWardNotTS: 0,
      reportedAtTSNotWard: 0,
    };

    data.forEach((row) => {
      // console.log(row.condemnedVehicles, "condennedevehuicles");
      totals.totalVehicles += row.totalVehicles || 0;
      totals.condemnedVehicles += row.condemnedVehicles || 0;
      totals.repairVehicles += row.repairVehicles || 0;
      totals.activeVehicles += row.activeVehicles || 0;
      totals.totalInActive += row.totalInActive || 0;
      totals.reportedAtWard += row.reportedAtWard || 0;
      totals.notReportedAtWard += row.notReportedAtWard || 0;
      totals.reportedAtWardAndTS += row.reportedAtWardAndTS || 0;
      totals.reportedAtWardNotTS += row.reportedAtWardNotTS || 0;
      totals.reportedAtTSNotWard += row.reportedAtTSNotWard || 0;
    });

    return totals;
  };

  const calculateCircleTotals = (data) => {
    const totals = {
      slno: "Total",
      circleName: "Total",
      totalVehicles: 0,
      condemnedVehicles: 0,
      repairVehicles: 0,
      activeVehicles: 0,
      totalInActive: 0,
      reportedAtWard: 0,
      notReportedAtWard: 0,
      reportedAtWardAndTS: 0,
      reportedAtWardNotTS: 0,
      reportedAtTSNotWard: 0,
    };

    data.forEach((row) => {
      totals.totalVehicles += row.totalVehicles || 0;
      totals.condemnedVehicles += row.condemnedVehicles || 0;
      totals.repairVehicles += row.repairVehicles || 0;
      totals.activeVehicles += row.activeVehicles || 0;
      totals.totalInActive += row.totalInActive || 0;
      totals.reportedAtWard += row.reportedAtWard || 0;
      totals.notReportedAtWard += row.notReportedAtWard || 0;
      totals.reportedAtWardAndTS += row.reportedAtWardAndTS || 0;
      totals.reportedAtWardNotTS += row.reportedAtWardNotTS || 0;
      totals.reportedAtTSNotWard += row.reportedAtTSNotWard || 0;
    });

    return totals;
  };

  const totalZoneRow = calculateZoneTotals(getZoneReport);
  const zoneDataWithTotal = [...getZoneReport, totalZoneRow];
  // const zoneDataWithTotal = [...getZoneReport];

  const totalCircleRow = calculateCircleTotals(getCircleReport);
  const circleDataWithTotal = [...getCircleReport, totalCircleRow];

  const handleTransferstaationChange = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option") {
      setSelectedTransferstation(newValue.value);
    } else if (actionMeta.action === "create-option") {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedTransferstation(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === "clear") {
        setSelectedTransferstation(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  const handleCreateOption = (inputValue) => {
    if (inputValue) {
      const newValue = { label: inputValue, value: inputValue.toLowerCase() };
      setOpts((prevOptions) => [...prevOptions, newValue]);
      if (typeof setSelectedTransferstation === "function") {
        setSelectedTransferstation(newValue.value);
      } else {
        console.error("setSelectedTransferstation is not a function");
      }
    }
  };

  const handleTransferstationChangeCircle = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option") {
      setSelectedTransferstationCircle(newValue.value);
    } else if (actionMeta.action === "create-option") {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedTransferstationCircle(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === "clear") {
        setSelectedTransferstationCircle(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  const handleCreateCircleTransferstationOption = (inputValue) => {
    if (inputValue) {
      const newValue = { label: inputValue, value: inputValue.toLowerCase() };
      setOptsTransferstation((prevOptions) => [...prevOptions, newValue]);
      if (typeof setSelectedTransferstationCircle === "function") {
        setSelectedTransferstationCircle(newValue.value);
      } else {
        console.error("setSelectedTransferstationCircle is not a function");
      }
    }
  };

  const handleVehicleNumberChange = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option") {
      setSelectedVehicleNo(newValue.value);
    } else if (actionMeta.action === "create-option") {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedVehicleNo(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === "clear") {
        setSelectedVehicleNo(null); // Ensure selectedOwnerType is cleared
      }
    }
    // console.log(newValue);
    localStorage.setItem("ZoneVehicleNumber", JSON.stringify(newValue));
  };

  const handleVehicleNumberChangeCircle = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option") {
      setSelectedVehicleNoCircle(newValue.value);
    } else if (actionMeta.action === "create-option") {
      const newValueOption = { label: newValue.label, value: newValue.value };
      selectedVehilceNoCircle(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === "clear") {
        selectedVehilceNoCircle(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  const handleCreateVehicleCircleOption = (inputValue) => {
    if (inputValue) {
      const newValue = { label: inputValue, value: inputValue.toLowerCase() };
      setOptsVehicleCircle((prevOptions) => [...prevOptions, newValue]);
      if (typeof setSelectedVehicleNoCircle === "function") {
        setSelectedVehicleNoCircle(newValue.value);
      } else {
        console.error("setSelectedVehicleNoCircle is not a function");
      }
    }
  };

  const handleCreateVehicleOption = (inputValue) => {
    if (inputValue) {
      const newValue = { label: inputValue, value: inputValue.toLowerCase() };
      setOptsVehicle((prevOptions) => [...prevOptions, newValue]);
      if (typeof setSelectedVehicleNo === "function") {
        setSelectedVehicleNo(newValue.value);
      } else {
        console.error("setSelectedVehicleNo is not a function");
      }
    }
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">SATs Dashboard Day Detailed Report</h4>
            <div className="page-header">
              <div className="card">
                <div className="card-body">
                  <Tabs
                    selectedIndex={selectedTab}
                    onSelect={(index) => {
                      setSelectedTab(index);
                      setTab(index);
                    }}
                  >
                    <TabList style={{ display: "flex" }}>
                      <Tab
                        className={`datatable_tabs ${isProd
                          ? selectedTab === 0
                            ? "active-ghmc"
                            : "active-swm"
                          : selectedTab === 0
                            ? "active-default"
                            : "inactive-default"
                          }`}
                      >
                        SATs Zone Wise Detailed Report
                      </Tab>
                      <Tab
                        className={`datatable_tabs ${isProd
                          ? selectedTab === 1
                            ? "active-ghmc"
                            : "active-swm"
                          : selectedTab === 1
                            ? "active-default"
                            : "inactive-default"
                          }`}
                      >
                        SATs Circle Wise Detailed Report
                      </Tab>
                    </TabList>
                    <TabPanel>
                      {/* <div className="text-end mt-3">
                        <button
                          className="btn btn-danger"
                          style={{ backgroundColor: "#EC1117" }}
                          onClick={() => downloadAsExcel(getZoneReport)}
                        >
                          Download Excel
                        </button>
                      </div> */}

                      <form onSubmit={handleSubmit}>
                        <div
                          class="row d-flex align-items-center mt-3"
                          style={{ textAlign: "justify" }}
                        >
                          <div class="col-md-2 ">
                            <label htmlFor="Date">Date:</label>
                            {/* <input
                                                            type="date"
                                                            id="Date"
                                                            style={{ backgroundColor: "#fff" }}
                                                            className="form-control"
                                                            value={Date}
                                                            onChange={(e) => setDate(e.target.value)}
                                                        /> */}
                            <input
                              type="date"
                              name="date"
                              value={zoneWiseFilters.date || getCurrentDate}
                              style={inputStyle}
                              className="form-control"
                              max={getCurrentDateTime()} // Set the max attribute to the current date
                              onChange={(e) => {
                                // zoneWiseFilters(e);
                                const { name, value } = e.target;
                                setZoneWiseFilter(name, value);
                              }}
                            />
                          </div>
                          <div class="col-md-2">
                            <label htmlFor="VehicleTypeId">Vehicle Type</label>
                            <select
                              className="form-select"
                              style={{ backgroundColor: "#fff" }}
                              name="VehicleTypeId"
                              value={zoneWiseFilters.VehicleTypeId}
                              id="VehicleTypeId"
                              // onChange={(e) => setVehicleTypeId(e.target.value)}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setZoneWiseFilter(name, value);
                              }}
                            >
                              <option value="">All</option>
                              {vehicleData
                                .filter((vehicle) => vehicle.isActive)
                                .map((vehicle) => (
                                  <option
                                    key={vehicle.vehicleTypeId}
                                    value={vehicle.vehicleTypeId}
                                  >
                                    {vehicle.vehicleTypeName}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div class="col-md-2">
                            <label htmlFor="Owner type">Owner Type</label>
                            <select
                              className="form-select"
                              style={inputStyle2}
                              name="ownerTypeId"
                              id="ownerType"
                              value={zoneWiseFilters.ownerTypeId}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setZoneWiseFilter(name, value);
                              }}
                            >
                              <option value="">Select</option>
                              {ownerTypeDetails
                                .filter((ownerType) => ownerType.isActive)
                                .map((ownerType) => (
                                  <option
                                    key={ownerType.ownerTypeId}
                                    value={ownerType.ownerTypeId}
                                  >
                                    {ownerType.ownerTypeName}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-md-2">
                            <label
                              htmlFor="Transferstation"
                              style={{ textAlign: "left" }}
                            >
                              Vehicle Number
                            </label>
                            <CreatableSelect
                              defaultValue={optionsVehicleValues[0]}
                              style={{ Height: "34px !important" }}
                              classNamePrefix="CreatableSelect"
                              inputId="vehicleNumber"
                              name="vehicleNumber"
                              id="vehicleNumber"
                              placeholder="Select"
                              options={optionsVehicleValues}
                              isClearable={true}
                              // onChange={handleVehicleNumberChange}
                              onChange={(selectedOption) => {
                                const value = selectedOption
                                  ? selectedOption.label
                                  : "";
                                setZoneWiseFilter("vehicleNumber", value);
                              }}
                              // onCreateOption={handleCreateVehicleOption}
                              value={
                                optionsVehicleValues.find(
                                  (option) =>
                                    option.label ===
                                    zoneWiseFilters.vehicleNumber
                                ) || null
                              }
                            />
                          </div>
                          <div className="col-md-2">
                            <label
                              htmlFor="loadingEquipment"
                              style={{ textAlign: "left" }}
                            >
                              Transferstation
                            </label>
                            <CreatableSelect
                              style={{ Height: "34px !important" }}
                              classNamePrefix="CreatableSelect"
                              inputId="transferStationId"
                              name="transferStationId"
                              id="transferStationId"
                              placeholder="Select"
                              options={optionsLoadingValues}
                              isClearable={true}
                              // onChange={handleTransferstaationChange}
                              onChange={(selectedOption) => {
                                // Use selectedOption.value to set the filter value
                                const value = selectedOption
                                  ? selectedOption.value
                                  : "";
                                setZoneWiseFilter("transferStationId", value);
                              }}
                              // onCreateOption={handleCreateOption}
                              value={
                                optionsLoadingValues.find(
                                  (option) =>
                                    option.value ===
                                    zoneWiseFilters.transferStationId
                                ) || null
                              }
                            />
                          </div>
                          <div class="col-md-2 d-flex gap-2">
                            <button
                              type="submit"
                              className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"
                                }`}
                            >
                              Search
                            </button>
                            <button
                              type="submit"
                              onClick={() => {
                                resetZoneWiseFilters();
                                setFormInput({
                                  Date: getCurrentDateTime(),
                                  VehicleTypeId: "",
                                  VehicleStatusId: "2",
                                });
                                setSelectedOwnerType("");
                              }}
                              className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"
                                }`}
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                        <div class="col-md-12 btn-excel-end">
                          <button
                            className="btn btn-excel mt-4 "
                            onClick={() => downloadAsExcel(getZoneReport)}
                          >
                            <i
                              class={`fa-solid fa-file-excel me-1 icon-container`}
                            ></i>{" "}
                            Excel
                          </button>
                        </div>
                      </form>
                      <div className="card mt-3">
                        <div className="">
                          <div className="top-header">
                            <span>Zone Wise SATs Reports on {zoneWiseFilters.date ? formattedDate(zoneWiseFilters.date) : getCurrentISTDate()} - (at {getCurrentDateTime1()})</span>
                          </div>
                          <CustomDataTable
                            data={zoneDataWithTotal}
                            totalZoneRow={totalZoneRow}
                            //  onRowClick={handleRowClick}
                            columns={satZoneColumns}

                            conditionalRowStyles={conditionalRowStyles}
                          />

                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel>

                      <form onSubmit={handleSubmit1}>
                        <div
                          class="row d-flex align-items-center mt-3"
                          style={{ textAlign: "justify" }}
                        >
                          <div class="col-md-2">
                            <label htmlFor="Date">Date:</label>
                            {/* <input
                                                            type="date"
                                                            id="Date"
                                                            style={{ backgroundColor: "#fff" }}
                                                            className="form-control"
                                                            value={Date}
                                                            onChange={(e) => setDate(e.target.value)}
                                                        /> */}
                            <input
                              type="date"
                              name="date"
                              value={circleWiseFilters.date || getCurrentDate}
                              style={inputStyle}
                              className="form-control"
                              max={getCurrentDateTime()} // Set the max attribute to the current date
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setCircleWiseFilter(name, value);
                              }}
                            />
                          </div>
                          <div class="col-md-2">
                            <label htmlFor="VehicleTypeId">Vehicle Type</label>
                            <select
                              className="form-select"
                              style={{ backgroundColor: "#fff" }}
                              name="VehicleTypeId"
                              id="VehicleTypeId"
                              value={circleWiseFilters.VehicleTypeId}
                              // onChange={(e) => setVehicleTypeId(e.target.value)}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setCircleWiseFilter(name, value);
                              }}
                            >
                              <option value="">All</option>
                              {vehicleData
                                .filter((vehicle) => vehicle.isActive)
                                .map((vehicle) => (
                                  <option
                                    key={vehicle.vehicleTypeId}
                                    value={vehicle.vehicleTypeId}
                                  >
                                    {vehicle.vehicleTypeName}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div class="col-md-2">
                            <label htmlFor="Owner type">Owner Type</label>
                            <select
                              className="form-select"
                              style={inputStyle2}
                              name="ownerTypeId"
                              id="ownerType"
                              value={circleWiseFilters.ownerTypeId}
                              onChange={(e) => {
                                const { name, value } = e.target;
                                setCircleWiseFilter(name, value);
                              }}
                            >
                              <option value="">Select</option>
                              {ownerTypeDetailsCircle
                                .filter((ownerType) => ownerType.isActive)
                                .map((ownerType) => (
                                  <option
                                    key={ownerType.ownerTypeId}
                                    value={ownerType.ownerTypeId}
                                  >
                                    {ownerType.ownerTypeName}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-md-2">
                            <label
                              htmlFor="Transferstation"
                              style={{ textAlign: "left" }}
                            >
                              Vehicle Number
                            </label>
                            <CreatableSelect
                              classNamePrefix="CreatableSelect"
                              style={{ Height: "34px !important" }}
                              inputId="vehicleNumber"
                              name="vehicleNumber"
                              id="vehicleNumber"
                              placeholder="Select"
                              options={optionsVehicleCircleValues}
                              isClearable={true}
                              onChange={(selectedOption) => {
                                // Use selectedOption.value to set the filter value
                                const value = selectedOption
                                  ? selectedOption.label
                                  : "";
                                setCircleWiseFilter("vehicleNumber", value);
                              }}
                              // onChange={handleVehicleNumberChangeCircle}
                              // onCreateOption={handleCreateVehicleCircleOption}
                              value={
                                optionsVehicleCircleValues.find(
                                  (option) =>
                                    option.label ===
                                    circleWiseFilters.vehicleNumber
                                ) || null
                              }
                            />
                          </div>
                          <div className="col-md-2">
                            <label
                              htmlFor="transferStation"
                              style={{ textAlign: "left" }}
                            >
                              Transferstation
                            </label>
                            <CreatableSelect
                              classNamePrefix="CreatableSelect"
                              style={{ Height: "34px !important" }}
                              inputId="transferStationId"
                              name="transferStationId"
                              id="transferStation"
                              placeholder="Select"
                              options={optionsCircleTransferstationValues}
                              isClearable={true}
                              // onChange={handleTransferstationChangeCircle}
                              // onCreateOption={
                              //   handleCreateCircleTransferstationOption
                              // }
                              onChange={(selectedOption) => {
                                // Use selectedOption.value to set the filter value
                                const value = selectedOption
                                  ? selectedOption.value
                                  : "";
                                setCircleWiseFilter("transferStationId", value);
                              }}
                              value={
                                optionsCircleTransferstationValues.find(
                                  (option) =>
                                    option.value ===
                                    circleWiseFilters.transferStationId
                                ) || null
                              }
                            />
                          </div>
                          <div class="col-md-2 d-flex gap-2">
                            <button
                              type="submit"
                              className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"
                                }`}
                            >
                              Search
                            </button>
                            <button
                              type="submit"
                              onClick={() => {
                                resetCircleWiseFilters();
                                setFormInput({
                                  Date: getCurrentDateTime(),
                                  VehicleTypeId: "",
                                  VehicleStatusId: "2",
                                });
                                setSelectedOwnerType("");
                              }}
                              className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"
                                }`}
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                        <div class="col-md-12 btn-excel-end">
                          <button
                            className="btn btn-excel mt-4"
                            onClick={() => downloadAsExcel1(getCircleReport)}
                          >
                            <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                            Excel
                          </button>
                        </div>
                      </form>
                      <div className="card mt-3">
                        <div className="">
                          <div className="top-header">
                            <span>Circle Wise SATs Reports on {circleWiseFilters.date ? formattedDate(circleWiseFilters.date) : getCurrentDateTime()} - (at {getCurrentDateTime1()})</span>
                          </div>
                          <CustomDataTable
                            data={circleDataWithTotal}
                            columns={satCircleColumns}
                          //onRowClick={handleRowClick}
                          />
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DetailedReport;

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const inputStyle = {
  backgroundColor: "#fff",
  border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",
};

const inputStyle2 = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  // padding: "15px",
  borderRadius: "0px",
};
